'use strict';

/**
 * Created by kinsellad on 30/01/2017.
 */
define(['app'], function (app) {

  var productBlock = function productBlock() {
    var self = this;
    self.app = app; // locally reference app object

    var _config = {
      buttonSelector: '[data-js-element=button]',
      buttonClickEvent: 'productBlock-buttonClick',
      quickViewIconSelector: '[data-js-element=quickViewIcon]',
      quickViewIconClickEvent: 'productBlock-quickViewClick',
      productDataSelector: '[data-js-element=productBlock_data]'
    };

    var _init = function _init(element) {
      self.element = element;
      self.button = self.element.querySelector(self.config.buttonSelector);
      self.quickViewIcon = self.element.querySelector(self.config.quickViewIconSelector);
      self.productData = self.element.querySelector(self.config.productDataSelector);
      _bind();
      return self;
    };

    var _bind = function _bind() {
      if (self.button) {
        self.button.addEventListener('click', _buttonClicked);
      }
      if (self.quickViewIcon) {
        self.quickViewIcon.addEventListener('click', _quickViewIconClicked);
      }
    };

    var _buttonClicked = function _buttonClicked() {
      self.app.publish(self.config.buttonClickEvent);
    };

    var _quickViewIconClicked = function _quickViewIconClicked(event) {
      //This currently triggers the old quickview component
      event.preventDefault();
      self.app.publish(self.config.quickViewIconClickEvent);
    };

    self.config = _config;
    self.init = _init;
  };

  return productBlock;
});
//# sourceMappingURL=productBlock.js.map
